import { observer } from 'mobx-react-lite';
import { QueueColumnHeader } from './queue-column-header';
import { queueColumnHeaderTestIds } from './test-ids';
import { HStack, Icon, Text, Box } from '@cad-arc';
import { useColumnDisplayNames } from '../hooks/use-column-display-names';
import { WorkspaceQueue } from '../../panels/workspace-queue';
import { ColumnDefinitionEnumType } from '@mark43/cad-api';
import { Tooltip } from '~/common/components/tooltip';

export const QueueColumnHeaders = observer(function QueueColumnHeaders({
    workspaceQueue,
    onReorder,
    onResize,
    onSort,
}: {
    workspaceQueue: WorkspaceQueue;
    onResize: (width: string, columnKey: ColumnDefinitionEnumType) => void;
    onSort: (definition: ColumnDefinitionEnumType) => void;
    onReorder: (columnDefinitionName: ColumnDefinitionEnumType, newIndex: number) => void;
}) {
    const columnDisplayNames = useColumnDisplayNames();
    return (
        <>
            {workspaceQueue.queueColumns.map((column, index) => {
                const isSortColumn =
                    workspaceQueue.sortByQueueColumnDefinition === column.columnDefinition;
                const sortOrder = isSortColumn ? workspaceQueue.sortDirection : null;
                const columnDisplayName = columnDisplayNames[column.columnDefinition];
                return (
                    <QueueColumnHeader
                        key={column.columnDefinition}
                        index={index}
                        header={
                            <HStack data-testid="queue-column-header" style={{ gap: '0' }}>
                                <Box color={isSortColumn ? 'selected.default' : 'inherit'}>
                                    <Tooltip overlay={columnDisplayName.displayName}>
                                        <Text style={{ pointerEvents: 'auto' }} color="inherit">
                                            {columnDisplayName.displayAbbreviation}
                                        </Text>
                                    </Tooltip>
                                </Box>
                                {isSortColumn && (
                                    <Icon
                                        icon={
                                            // ascending is a down arrow as in "increases from top to bottom"
                                            sortOrder === 'REGULAR_ASCENDING'
                                                ? 'ArrowDownNarrow'
                                                : 'ArrowUpNarrow'
                                        }
                                        data-testid={
                                            sortOrder === 'REGULAR_ASCENDING'
                                                ? queueColumnHeaderTestIds.COLUMN_SORT_ASCENDING
                                                : queueColumnHeaderTestIds.COLUMN_SORT_DESCENDING
                                        }
                                        size="sm"
                                        color="selected.default"
                                        style={{ marginLeft: '0px' }}
                                    />
                                )}
                            </HStack>
                        }
                        columnDefinition={column.columnDefinition}
                        onSort={onSort}
                        onResize={onResize}
                        onReorder={onReorder}
                    />
                );
            })}
        </>
    );
});
